import { useQuery } from '@tanstack/react-query';
import { GetPrReleaseBySlugQuery } from '@/graphql/gql/graphql';
import { GetReleaseBySlugArgs } from '@/types/release';
import { getReleaseBySlug } from '../api';

const useReleaseBySlug = ({ slug, isDraft }: GetReleaseBySlugArgs) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['release', slug, isDraft],
    queryFn: () => getReleaseBySlug({ slug, isDraft }),
    select: (response: GetPrReleaseBySlugQuery) => {
      const releases = response.allPrRelease ?? [];
      return releases[0];
    },
  });

  return { data, isError, isLoading };
};

export default useReleaseBySlug;
